import { defineStore } from "pinia";
import { useApiStore as api } from "../apiStore";
// import { useSiteStore as siteStore } from '../siteStore';
import protocol from "@/protocol/protocol";
import i18n from "@/utils/i18n";
import vtkWSLinkClient from "vtk.js/Sources/IO/Core/WSLinkClient";
import SmartConnect from "wslink/src/SmartConnect";
import { useSsaStore as ssa } from ".";
import { usePanelStore } from "../panelStore";
import { useToastStore as toast } from "../toastStore";
import { useBusyStore as busy } from "./busy";
import { usePvwStore as pvw } from "./pvw";

vtkWSLinkClient.setSmartConnectClass(SmartConnect);

export const useWslinkStore = defineStore("wslinkStore", {
	state: () =>
		({
			sessionManagerURL: null,
			client: null,
			config: { application: "dcui" },
			error: null,
			connected: false,
			existingSession: true,
			connecting: false,
			connectionError: false,
			isWsLinkDisconnected: false
		}) as {
			sessionManagerURL: string | null;
			client: any;
			config: { application: "dcui" };
			error: any;
			connected: boolean;
			existingSession: any;
			connecting: boolean;
			connectionError: boolean;
			isWsLinkDisconnected: boolean;
		},
	getters: {
		IS_WSLINK_DISCONNECTED(): boolean {
			return this.isWsLinkDisconnected;
		},
		WSLINK_CONNECTING(): boolean {
			return this.connecting;
		},
		WSLINK_EXISTING_SESSION(): any {
			return this.existingSession;
		},
		WSLINK_CONNECTED(): any {
			return this.connected;
		},
		WSLINK_CLIENT(): any {
			return this.client;
		},
		WSLINK_CONFIG(): any {
			return this.config;
		},
		WSLINK_ERROR(): any {
			return this.error;
		}
	},
	actions: {
		SET_IS_WSLINK_DISCONNECTED(status: boolean) {
			this.isWsLinkDisconnected = status;
		},
		WSLINK_SESSION_MANAGER_URL_SET(value: string) {
			this.sessionManagerURL = value;
		},
		WSLINK_CONNECTED_SET(value: any) {
			this.connected = value;
		},
		WSLINK_CLIENT_SET(client: any) {
			this.client = client;
		},
		WSLINK_CONFIG_SET(config: any) {
			this.config = config;
		},
		WSLINK_ERROR_SET(msg: any) {
			this.error = msg;
		},
		EXISTING_SESSION_SET(value: any) {
			this.existingSession = value;
		},
		// async SSA_REQUEST_NEW_PARAVIEW({commit, dispatch}){

		//     commit('AUTH_IS_LOADING_SET', true);
		//     commit('EXISTING_SESSION_SET', false);
		//     localStorage.removeItem('sessionUrl')
		//     localStorage.removeItem('sessionSecret');

		//     await  dispatch('SSA_DISCONNECT');
		//     commit('WSLINK_CONNECTED_SET', false);
		//     let client = await dispatch('WSLINK_CONNECT');
		//     commit('PVW_CLIENT_SET', client);
		//     dispatch('SSA_INITIALIZE');
		//     commit('AUTH_IS_LOADING_SET', false);
		//     window.location.reload();
		//     // dispatch('LOAD_BLANK_STATE');

		//   },
		WSLINK_CONNECT() {
			this.connecting = true;

			this.sessionManagerURL = api().config!.endpoints.api + "/paraview/create-session";
			return new Promise((resolve, reject) => {
				// get class variables for connected client instance
				const { config, client, sessionManagerURL } = this;

				// check if already connected
				if (client && client.isConnected()) {
					try {
						client.disconnect();
					} catch (e) {
						toast().toast({
							message: "",
							title: i18n.global.t("toastGeneralError"),
							type: "error",
							dismissable: false
						});
						console.error(e);
					}
					this.connected = false;
				}
				let clientToConnect = client;
				if (!clientToConnect) {
					clientToConnect = vtkWSLinkClient.newInstance();
					clientToConnect.setProtocols({
						DataCloud: protocol
					});
				}
				clientToConnect.onBusyChange((count: any) => {
					busy().BUSY_COUNT_SET(count);
					return count;
				});
				clientToConnect.beginBusy();
				// Error
				clientToConnect.onConnectionError((httpReq: any) => {
					return httpReq;
					// const message =
					//   (httpReq && httpReq.response && httpReq.response.error) ||
					//   `Connection error`;
					// if((httpReq && httpReq.response && httpReq.response.error) && httpReq.response.code == -32000){
					//   // localStorage.removeItem('sessionUrl');
					//   // localStorage.removeItem('sessionSecret');
					//   // connectFunction(resolve,reject);
					// }else{
					//   // commit('WSLINK_ERROR_SET', message);
					//   // commit('WSLINK_CONNECTED_SET', false);
					// }
					//reject();
				});
				// Close

				clientToConnect.onConnectionClose((httpReq: any) => {
					this.isWsLinkDisconnected = true;
					return httpReq;
					// const message =
					//   (httpReq && httpReq.response && httpReq.response.error) ||
					//   `Connection close`;
					// console.error(message);
					// commit('WSLINK_ERROR_SET', message);
					// commit('WSLINK_CONNECTED_SET', false);
					//  reject();
				});
				// Connect
				let count = 0;
				const connectFunction = async (resolve: any, reject: any) => {
					count += 1;
					const sessionURL = localStorage.getItem("sessionUrl");
					const secret = localStorage.getItem("sessionSecret");
					const conf =
						sessionURL != null && secret != null
							? { sessionURL, secret }
							: { sessionManagerURL };
					try {
						const validClient = await clientToConnect.connect(
							Object.assign({}, config, conf),
							(decoratedConfig: any) => {
								decoratedConfig.headers = decoratedConfig.headers || {};
								Object.assign(
									decoratedConfig.headers,
									{ Authorization: `Bearer ${api().apiToken}` },
									{ "Access-Control-Allow-Origin": "*" },
									{ "Content-Type": "application/json" }
								);
								return decoratedConfig;
							}
						);
						const { sessionURL, secret } = await validClient.getConfig();
						localStorage.setItem("sessionUrl", sessionURL);
						localStorage.setItem("sessionSecret", secret);
						this.client = validClient;
						clientToConnect.endBusy();
						this.connected = true;

						resolve(validClient);
					} catch (e) {
						if (count > 2) {
							reject(new Error("fail"));
							// ================ TODO SETUP APPLICATION ERROR HANDLER ================== //
							//dispatch('PUSH_APP_ERROR', {catastrophic:true, message:'There was a problem connecting to our servers. Please try again later.'})
						} else {
							console.log("error connecting to paraview");
							localStorage.removeItem("sessionUrl");
							localStorage.removeItem("sessionSecret");
							this.existingSession = false;
							setTimeout(() => {
								try {
									connectFunction(resolve, reject);
								} catch (e) {
									reject(new Error("fail"));
								}
							}, 1000);
						}
					}
				};
				try {
					connectFunction(resolve, reject);
				} catch (e) {
					reject(new Error("fail"));
				}
			});
		},
		WSLINK_DISCONNECT() {
			return new Promise((resolve: any, reject: any) => {
				const { client } = this;
				if (client && client.isConnected()) {
					try {
						client.disconnect();
						resolve();
					} catch (e) {
						toast().toast({
							message: "",
							title: i18n.global.t("toastGeneralError"),
							type: "error",
							dismissable: false
						});
						console.error(e);
						reject(e);
					}
					// commit('WSLINK_CONNECTED_SET', false);
				}
			});
		},
		async SSA_RESET_STORE() {
			localStorage.removeItem("v-layout");
			localStorage.removeItem("wslinkStore");
			localStorage.removeItem("layerStore");
			localStorage.removeItem("viewStore");
			localStorage.removeItem("activeStore");
			localStorage.removeItem("presetsStore");
			localStorage.removeItem("displayPaneStore");
			localStorage.removeItem("pvwStore");
			localStorage.removeItem("hierarchyStore");
			localStorage.removeItem("sessionUrl");
			localStorage.removeItem("sessionSecret");
		},
		async SSA_SET_CONNECTION_ERROR(value = false) {
			this.connectionError = value;
		},
		async SSA_REQUEST_NEW_PARAVIEW(reload = true, skipOnSessionExist = true) {
			return new Promise((resolve, reject) => {
				localStorage.removeItem("v-layout");
				//commit('AUTH_IS_LOADING_SET', true); // TODO SET LOADING
				// commit('EXISTING_SESSION_SET', false); // TODO CREATE EXISTING SESSION RECALL // Might be done via skipOnSessionExist flag? Delete TODO if this is sufficient
				// console.log(skipOnSessionExist);
				//if (!skipOnSessionExist) {
				localStorage.removeItem("sessionUrl");
				localStorage.removeItem("sessionSecret");
				// }

				ssa().SSA_DISCONNECT();
				this.WSLINK_CONNECTED_SET(false);
				this.WSLINK_CONNECT().then(
					(client) => {
						pvw().PVW_CLIENT_SET(client);
						ssa()
							.SSA_INITIALIZE()
							.then(
								() => {
									usePanelStore().SET_READY(true);
									if (reload) {
										localStorage.removeItem("viewStore");
										localStorage.removeItem("activeStore");
										localStorage.removeItem("presetsStore");
										localStorage.removeItem("hierarchyStore");
										localStorage.removeItem("displayPaneStore");
										localStorage.removeItem("pvwStore");
										localStorage.removeItem("layerStore");
										window.location.reload();
									}
									resolve(true);
								},
								() => {
									console.log("eror");
								}
							);

						// commit('AUTH_IS_LOADING_SET', false); //TODO SET LOADING
					},
					() => {
						this.SSA_SET_CONNECTION_ERROR(true);
						reject(new Error("fail"));
					}
				);
			});
		}
	}
});
